import {
  Create, Edit, SimpleForm, Toolbar, SaveButton, TextInput, NumberInput, AutocompleteArrayInput,
  required, regex, useGetList, useRecordContext, useRefresh,
} from 'react-admin';
import { Box, Stack, Typography } from '@mui/material';
import { layout, badgeStyle, typo, WEBSITE_PUBLICATION_STATE } from '../styles/ds';
import { CategoryPublicationButton } from './WebsiteCategoryList';
import CategoryListingsOrder from './CategoryListingsOrder';
import { withSlugFromName } from './formHelpers';

const slugRule = regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, 'אותיות אנגליות קטנות, ספרות ומקפים בלבד (לדוגמה: tefillin)');

const CategoryFields = ({ isCreate = false }) => {
  const { data: products = [] } = useGetList('products', {
    pagination: { page: 1, perPage: 1000 }, sort: { field: 'name', order: 'ASC' },
  });
  return (
    <>
      <Box sx={layout.formGrid}>
        <TextInput source="name_en" label="שם באתר (אנגלית)" fullWidth validate={required('שדה חובה')} />
        <TextInput source="slug" label="כתובת (slug)" fullWidth validate={isCreate ? [slugRule] : [required('שדה חובה'), slugRule]}
          helperText={isCreate ? 'אפשר להשאיר ריק — תיווצר אוטומטית מהשם באנגלית' : 'חלק מכתובת הדף באתר — שינוי שובר קישורים קיימים'} />
        <NumberInput source="sort_position" label="סדר תצוגה" fullWidth defaultValue={0} />
      </Box>
      <AutocompleteArrayInput source="crm_product_ids" label="מוצרי מקור ב-CRM" fullWidth
        choices={products.map(p => ({ id: p.id, name: p.name }))}
        helperText="מוצרי ה-CRM שמהם נלקחים מוצרי האתר בקטגוריה (לעיון ולסינון בלבד)" />
    </>
  );
};

const CategoryStatus = () => {
  const record = useRecordContext();
  const refresh = useRefresh();
  if (!record) return null;
  return (
    <Stack direction="row" alignItems="center" spacing={2} mb={2} flexWrap="wrap" useFlexGap>
      <Typography sx={typo.sectionTitle}>מצב פרסום:</Typography>
      <span style={badgeStyle(WEBSITE_PUBLICATION_STATE, record.publication_state)}>
        {WEBSITE_PUBLICATION_STATE[record.publication_state]?.label}
      </span>
      <CategoryPublicationButton category={record} onDone={refresh} />
    </Stack>
  );
};

// No delete: categories are unpublished, never removed (no DELETE route).
const SaveOnlyToolbar = () => <Toolbar><SaveButton label="שמירה" /></Toolbar>;

export const WebsiteCategoryCreate = () => (
  <Create title="קטגוריית אתר חדשה" redirect="list" transform={withSlugFromName}>
    <SimpleForm defaultValues={{ crm_product_ids: [] }}>
      <CategoryFields isCreate />
    </SimpleForm>
  </Create>
);

// Pessimistic: the server checks `version` (409 when someone else saved first),
// so the error must surface before the form is left.
export const WebsiteCategoryEdit = () => (
  <Edit title="עריכת קטגוריית אתר" mutationMode="pessimistic" redirect="list">
    <SimpleForm toolbar={<SaveOnlyToolbar />}>
      <CategoryStatus />
      <CategoryFields />
      <CategoryListingsOrder />
    </SimpleForm>
  </Edit>
);
